export default __webpack_public_path__ + "static/media/logo.40bb3aaf.svg";